var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SampleStatsRequest_1;
import { ReusableLogic } from '@symon-ai/wisepipe-common-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { DataRequest, RequestType } from './dataRequest';
import { sampleStatsRequestSchemaValidation } from '../validations.generated';
export const sampleStatsRequestSchema = {
    $id: 'urn:wisepipe-common-computation:SampleStatsRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        port: { type: 'string', minLength: 1 },
        reusableLogicParentNodeIDPath: { type: 'string', minLength: 1 },
        isNodeRLInput: { type: 'boolean' },
        draftReusableLogicIDs: { type: 'array', items: { type: 'string' } }
    },
    required: ['pipeID', 'elementID', 'port'],
    if: { anyOf: [{ required: ['isNodeRLInput'] }, { required: ['draftReusableLogicIDs'] }] },
    then: { required: ['reusableLogicParentNodeIDPath'] }
};
let SampleStatsRequest = SampleStatsRequest_1 = class SampleStatsRequest extends DataRequest {
    constructor(pipeID, elementID, port, filters, reusableLogicParentNodeIDPath, isNodeRLInput, draftReusableLogicIDs) {
        super(RequestType.SampleStats, filters, pipeID);
        this.port = port;
        this.pipeID = pipeID;
        this.elementID = elementID;
        this.reusableLogicParentNodeIDPath = reusableLogicParentNodeIDPath;
        this.isNodeRLInput = isNodeRLInput;
        this.draftReusableLogicIDs = draftReusableLogicIDs;
        JSON.validate(this, SampleStatsRequest_1);
    }
    // Results for elements within RLs have special naming convention in S3
    getElementIDForS3() {
        return ReusableLogic.getElementIDForS3(this.elementID, this.reusableLogicParentNodeIDPath, this.isNodeRLInput);
    }
};
SampleStatsRequest = SampleStatsRequest_1 = __decorate([
    JsonSchemaV2(sampleStatsRequestSchema, sampleStatsRequestSchemaValidation),
    JsonDiscriminatorValue(RequestType.SampleStats)
], SampleStatsRequest);
export { SampleStatsRequest };
//# sourceMappingURL=sampleStatsRequest.js.map